export default "__VITE_ASSET__3P7O_8I$__"